import React, { useEffect, useState } from 'react';
import { api } from '@/lib/api';

export default function SystemStatusPanel() {
  const [status, setStatus] = useState(null);
  const [error, setError] = useState(false);
  useEffect(() => {
    let active = true;
    const load = async () => {
      try {
        const { data } = await api.get('/admin/platform/system-status');
        if (active) { setStatus(data); setError(false); }
      } catch {
        if (active) { setStatus(null); setError(true); }
      }
    };
    load();
    const timer = setInterval(load, 30000);
    return () => { active = false; clearInterval(timer); };
  }, []);
  const backup = status?.backup;
  return <section className="border border-border bg-card p-5" data-testid="system-status-panel">
    <h3 className="font-display text-lg">System status</h3>
    {error ? <p role="alert" className="text-sm text-amber-600 mt-2">System checks are unavailable. Previous results are not shown.</p> :
      !status ? <p className="text-sm text-muted-foreground mt-2">Checking connections…</p> : <>
        <p className="text-xs text-muted-foreground mt-1">Release {status.release?.version || 'unknown'} · Checked {new Date(status.checkedAt).toLocaleString()}</p>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 my-3">
          {['database', 'storage', 'mqtt'].map(name => <div key={name} className="border border-border p-3">
            <span className="capitalize">{name === 'mqtt' ? 'Notifications' : name}</span>: <strong>{status[name] || 'unknown'}</strong>
          </div>)}
        </div>
        <p className="text-sm">Last verified backup: {backup?.status === 'verified' ? new Date(backup.verifiedAt).toLocaleString() : 'Unknown'}</p>
        {backup?.status === 'verified' && <p className="text-xs text-muted-foreground mt-1">Database and media archive verification completed. Full recovery rehearsal: {backup.restoreRehearsed ? 'recorded' : 'not recorded'}.</p>}
      </>}
  </section>;
}
